import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { apiFetch } from "@/lib/api";
import type { VoceSettimana, VoceSettimanaCreate } from "@/types/api";

/** Invalida sia la lista admin sia la casella della Panoramica. */
function useInvalida() {
  const qc = useQueryClient();
  return () => {
    qc.invalidateQueries({ queryKey: ["admin-settimana"] });
    qc.invalidateQueries({ queryKey: ["settimana"] });
  };
}

export function useAdminSettimana() {
  return useQuery({
    queryKey: ["admin-settimana"],
    queryFn: () => apiFetch<VoceSettimana[]>("/api/v1/admin/settimana"),
    staleTime: 15_000,
  });
}

export function useCreaVoceSettimana() {
  const invalida = useInvalida();
  return useMutation({
    mutationFn: (body: VoceSettimanaCreate) =>
      apiFetch<VoceSettimana>("/api/v1/admin/settimana", {
        method: "POST",
        body: JSON.stringify(body),
      }),
    onSuccess: invalida,
  });
}

export function useAggiornaVoceSettimana() {
  const invalida = useInvalida();
  return useMutation({
    mutationFn: ({ id, body }: { id: string; body: Partial<VoceSettimanaCreate> }) =>
      apiFetch<VoceSettimana>(`/api/v1/admin/settimana/${id}`, {
        method: "PATCH",
        body: JSON.stringify(body),
      }),
    onSuccess: invalida,
  });
}

export function useEliminaVoceSettimana() {
  const invalida = useInvalida();
  return useMutation({
    mutationFn: (id: string) =>
      apiFetch<void>(`/api/v1/admin/settimana/${id}`, { method: "DELETE" }),
    onSuccess: invalida,
  });
}
